import { Box, Button, FormField, Select, Image, Stack } from "grommet";
import React from "react";
import FactionViewOld from "./FactionViewOld";
import axios from "./general/HttpClient";
import { BrowseThemes, Theme } from "./ThemeStore";

export interface Faction {
    id: number;
    name: string;
    description: string;
    strategy: string;
    factionTheme: string;
    visualDescription: string;

    setID: string;
    themeID: number;
    imageID: number;
}

const FactionsHome = () => {
    const [factions, setFactions] = React.useState([] as Faction[]);
    const listFactions = () => {
        axios.get("/api/factions/browse").then((response) => {
            setFactions(response.data);
        });
    };

    React.useEffect(() => {
        listFactions();
        BrowseThemes().then((response) => {
            setThemes(response.data);
        });
    }, []);

    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState("");

    const generateFactions = () => {
        setLoading(true);
        setMessage("Generating Factions...");
        if (selectedTheme.id) {
            axios.get("/api/factions/generateFactions", { params: { themeId: selectedTheme.id } }).then((response) => {
                listFactions();
                setLoading(false);
            });
        }
    };

    const [themes, setThemes] = React.useState([] as Theme[]);
    const [selectedTheme, setSelectedTheme] = React.useState({} as Theme);

    return (
        <>
            <FormField label="Theme">
                <Select options={themes} value={selectedTheme} labelKey="name" onChange={({ value }) => setSelectedTheme(value)}></Select>
            </FormField>
            <Box direction="row">
                {loading && <Box>{message}</Box>}
                {!loading && <Button label="Generate Factions" onClick={generateFactions}></Button>}
            </Box>
            <Box align="center" justify="center">
                {factions.map((faction) => (
                    <FactionViewOld key={faction.id} faction={faction} onUpdate={() => listFactions()}></FactionViewOld>
                ))}
            </Box>
        </>
    );
};

export default FactionsHome;
